import {
  FormSellContract,
  SellContractApiParams,
  buildNewSellContract,
  SellContract,
  SellContractNumberKeys,
} from "@/models/SellContract";
import store, { StoreActions } from "@/store";
import { JSConn } from "@/utilities/js-conn";
import api from "@/api";

import { convertStringToNumber } from "@/utilities/controllerHelpers";
import { IlsctlNumberKeys } from "@/models/IlsctlLineItem";

const itemDetails = {
  pluralName: "sell_contracts",
  singularName: "sell_contract",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  const formParams = jsConn.formParams as FormSellContract;

  return {
    id: jsConn.formParams.id,
    sell_contract: {
      ...formParams,
    } as SellContractApiParams,
  };
};

export const scStringsToNumbers = (sc: SellContract) => {
  const newSc = convertStringToNumber(SellContractNumberKeys, { ...sc });
  const newLineItems = [...newSc.ilsctl_line_items];

  for (const ilsctl of newLineItems) {
    convertStringToNumber(IlsctlNumberKeys, ilsctl);
  }

  newSc.ilsctl_line_items = newLineItems;

  return newSc;
};

async function needSellContracts(jsConn: JSConn) {
  return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
    let tmpValue = [...jsConn.response];
    tmpValue = tmpValue.map(item => {
      return scStringsToNumbers(item);
    });

    return store.dispatch(StoreActions.loadSellContracts, tmpValue);
  });
}

async function needSellContract(jsConn: JSConn) {
  return api.getItem(jsConn, itemDetails).then((jsConn: JSConn) => {
    let tmpValue = { ...jsConn.response };
    tmpValue = scStringsToNumbers(tmpValue);
    return store.dispatch(StoreActions.loadSellContract, tmpValue);
  });
}

async function createSellContract(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .createItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      let tmpValue = { ...jsConn.response };
      tmpValue = scStringsToNumbers(tmpValue);
      return store.dispatch(StoreActions.loadSellContract, tmpValue);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function updateSellContract(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .updateItem(jsConn, itemDetails)
    .then((jsConn: JSConn) => {
      let tmpValue = { ...jsConn.response };
      tmpValue = scStringsToNumbers(tmpValue);
      return store.dispatch(StoreActions.loadSellContract, tmpValue);
    })
    .catch((jsConn: JSConn) => {
      return Promise.reject(jsConn);
    });
}

async function deleteSellContract(jsConn: JSConn) {
  jsConn.apiParams = apiParamsBuilder(jsConn);
  return api
    .deleteItem(jsConn, itemDetails)
    .then(jsConn => {
      store.dispatch(StoreActions.loadSellContract, buildNewSellContract());
      return Promise.resolve(jsConn);
    })
    .catch(jsConn => {
      return Promise.reject(jsConn);
    });
}

export const sellContractsController = {
  needSellContracts,
  needSellContract,
  createSellContract,
  updateSellContract,
  deleteSellContract,
};
